import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import * as R from 'ramda'

import QuestionMenuStore from './QuestionMenuStore'

import SearchLayout from '../components/Layouts/Search'
import DataTable from '../components/DataTable'
import Button from '../UniformComponents/Button'
import Anchor from '../UniformComponents/Anchor'
import Tooltip from '../UniformComponents/Tooltip'
import ConfirmationModal from '../UniformComponents/ConfirmationModal'
import Select from '../components/form/Select'
import Checkbox from '../components/form/Checkbox'

import '../assets/css/questionMenu.css'
import LinkButton from '../UniformComponents/LinkButton'
import QuestionBuilder from '../QuestionBuilder'
import { PageSwitchTab, tabOptions } from '../components/PageSwitchTab'

@observer
class QuestionMenu extends Component {
    constructor(props) {
        super(props)
        const { store } = this.props
        this.questionMenuStore = new QuestionMenuStore(store)
        this.setColumns()
    }

    async componentDidMount() {
        const { store, location } = this.props
        const { questionMenuStore } = this
        store.breadcrumps = [
            {
                name: 'question',
                url: '/question/',
                title: 'Question Library',
            },
        ]

        /*
        * use this to prevent mergefield failure from survey pages in questionBuilderStore
        */
        store.isQuestionMenu = true

        if (R.path(['userData', 'role'], store) > 110) {
            location.href = '/home/e/0108'
            return
        }

        await questionMenuStore.init()
    }

    componentWillUnmount() {
        const { store } = this.props
        store.isQuestionMenu = false
    }

    setColumns = () => {
        const { store } = this.props
        this.columns = [
            {
                name: 'Question short name',
                key: 'title',
                cellClass: 'bold',
            },
            {
                name: '',
                key: 'questionId',
                cellClass: 'overflow',
                dataTransform: (questionId, row) => (
                    <div className="survey-btn-wrapper">
                        <Anchor
                            cssClass="icon-link-btn"
                            onClick={() => { this.toggleEditable(questionId) }}
                        >
                            <Tooltip
                                text={i18n.t('edit_question')}
                                direction="left"
                            />
                            <i className="fa-light fa-edit" />
                        </Anchor>
                        {store.isMasterSuper() && (
                            <Anchor
                                cssClass="icon-link-btn"
                                onClick={() => { this.openDeleteConfirmationModal(row) }}
                            >
                                <Tooltip
                                    text={i18n.t('del_question')}
                                    direction="left"
                                />
                                <i className="fa-light fa-circle-xmark" />
                            </Anchor>
                        )}
                    </div>
                ),
            },
        ]
        if (store.isExploriClient()) {
            this.columns.splice(1, 0, {
                name: 'Category',
                key: 'questioncategory',
            })
        }
    }

    toggleEditable = (questionId) => {
        const { store } = this.props
        const { questionCategories, editQuestion } = this.questionMenuStore
        const categories = questionCategories.slice(1)
        store.questionDetails = {
            oid: store.isExploriClient() ? 1 : 3,
            contextOid: 1,
            questionId,
            editQuestion,
            questionCategories: categories,
        }
        store.showQuestionEditor = true
    }

    openDeleteConfirmationModal = (row) => {
        this.questionMenuStore.questionToDelete = row
    }

    closeDeleteConfirmationModal = () => {
        this.questionMenuStore.questionToDelete = null
    }

    newQuestion = () => {
        const { store } = this.props
        const { questionCategories, questionCategory, addQuestion } = this.questionMenuStore
        const categories = questionCategories.slice(1)
        store.questionDetails = {
            oid: store.isExploriClient() ? 1 : 3,
            contextOid: 1,
            categoryId: questionCategory.categoryId,
            addQuestion,
            questionCategories: categories,
        }
        store.showQuestionEditor = true
    }

    renderFilterOptions = () => {
        const { store } = this.props
        const { questionMenuStore } = this
        return (
            <Fragment>
                <br />
                {
                    store.isExploriClient() && (
                        <fieldset className="filter">
                            <Select
                                label={i18n.t('category')}
                                options={questionMenuStore.questionCategories}
                                onBlur={questionMenuStore.changeQuestionCategory}
                                value={questionMenuStore.selectedQuestionCategory}
                            />
                        </fieldset>
                    )
                }
                <fieldset className="filter">
                    <legend className="legend-title">
                        {i18n.t('product_type')}
                    </legend>
                    <div>
                        {Object.keys(questionMenuStore.productTypes).map((productType) => (
                            <Checkbox
                                name={`pt-${productType}`}
                                onBlur={questionMenuStore.toggleProductType}
                                checked={questionMenuStore.productTypes[productType].selected}
                                label={questionMenuStore.productTypes[productType].label}
                            />
                        ))}
                    </div>
                </fieldset>
                <fieldset className="filter">
                    <legend className="legend-title">
                        {i18n.t('survey_type', 'Survey type')}
                    </legend>
                    <div>
                        {Object.keys(questionMenuStore.surveyTypes).map((surveyType) => (
                            <Checkbox
                                name={`st-${surveyType}`}
                                onBlur={questionMenuStore.toggleSurveyType}
                                checked={questionMenuStore.surveyTypes[surveyType].selected}
                                label={i18n.t(`surveyType_${questionMenuStore.surveyTypes[surveyType].label}`)}
                            />
                        ))}
                    </div>
                </fieldset>
                <fieldset className="filter">
                    <legend className="legend-title">
                        {i18n.t('respondent_type', 'Respondent type')}
                    </legend>
                    <div>
                        {Object.keys(questionMenuStore.respondentTypes).map((respondentType) => (
                            <Checkbox
                                name={`rt-${respondentType}`}
                                onBlur={questionMenuStore.toggleRespondentType}
                                checked={questionMenuStore.respondentTypes[respondentType].selected}
                                label={questionMenuStore.respondentTypes[respondentType].label}
                            />
                        ))}
                    </div>
                </fieldset>
                <fieldset className="filter">
                    <legend className="legend-title">
                        {i18n.t('status')}
                    </legend>
                    <div>
                        <Checkbox
                            name={i18n.t('active')}
                            onBlur={questionMenuStore.toggleIsActive}
                            checked={questionMenuStore.showActive}
                            label={i18n.t('active')}
                        />
                    </div>
                </fieldset>
            </Fragment>
        )
    }

    renderButtons = () => {
        const { store } = this.props
        return (
            <Fragment>
                <Button
                    cssClass="add-button primary regular"
                    onClick={this.newQuestion}
                    label={i18n.t('add_question')}
                    icon="fa-light fa-circle-plus"
                />
                {(store.isExploriSuper()) && (
                    <Fragment>
                        <br />

                        <LinkButton
                            cssClass="add-button primary regular"
                            onClick={(e) => { e.stopPropagation() }}
                            href="/questioncategory/"
                            label={i18n.t('edit_question_cate')}
                            icon="fa-light fa-pen-circle"
                        />
                    </Fragment>
                )}
            </Fragment>
        )
    }

    renderTablePanel = () => {
        const { questionMenuStore } = this
        return (
            <DataTable
                store={questionMenuStore}
                dataSet={questionMenuStore.filteredList || []}
                columns={this.columns}
                inMemory
                cssClass="search-table"
            />
        )
    }

    renderGuide = () => (
        <div dangerouslySetInnerHTML={{
            __html: i18n.t('questionMenu.introText'),
        }}
        />
    )

    render() {
        const { store, location, history } = this.props
        const { questionMenuStore } = this
        const { deactivateQuestion, questionToDelete } = questionMenuStore

        return (
            <Fragment>
                <Fragment>
                    <PageSwitchTab
                        appStore={store}
                        location={location}
                        history={history}
                        tabOptions={tabOptions.questions}
                    />
                    <SearchLayout
                        pageTitle="Questions"
                        renderFilterOptions={this.renderFilterOptions}
                        renderButtons={this.renderButtons}
                        renderTablePanel={this.renderTablePanel}
                        renderGuide={this.renderGuide}
                        searchStore={questionMenuStore}
                        hideFilterAccordion={false}
                        store={store}
                        hasTopNav
                    />
                    {store.showQuestionEditor && (
                        <QuestionBuilder store={store} />
                    )}
                </Fragment>
                <ConfirmationModal
                    show={!!questionToDelete}
                    title="Are you sure?"
                    description={questionToDelete && i18n.t('questionMenu.deleteQuestion.desc', { questionTitle: questionToDelete.title })}
                    onClose={this.closeDeleteConfirmationModal}
                    onTrue={async () => {
                        if (questionToDelete) await deactivateQuestion(questionToDelete.questionId)
                        this.closeDeleteConfirmationModal()
                    }}
                    onFalse={this.closeDeleteConfirmationModal}
                />
            </Fragment>
        )
    }
}

export default QuestionMenu
